module.exports = "/assets/d8f733c29862385baad8d23a0aa0d073.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8U.png
// module id = 2278
// module chunks = 0